import React from "react";

import {
  StyledHeroSection,
  StyledImage,
  StyledSubtitle,
  StyledTitle,
} from "./style";

const HeroSection = ({ image, title, subtitle }) => {
  const Image = <StyledImage src={image} />;

  const Title = (
    <StyledTitle
      variant="heading1"
      fontSize={["36px", "42px", "48px"]}
      lineHeight={["48px", "52px", "56px"]}
    >
      {title}
    </StyledTitle>
  );

  const Subtitle = (
    <StyledSubtitle variant="paragraph2">{subtitle}</StyledSubtitle>
  );

  return (
    <StyledHeroSection>
      {Image}
      {Title}
      {Subtitle}
    </StyledHeroSection>
  );
};

export default HeroSection;
